import React from 'react';
import { motion } from 'framer-motion';
import { PenTool, BarChart, FileText } from 'lucide-react';
import { scrollToPricing } from './utils';
const tomos = [{
  id: 1,
  emoji: '📘',
  color: 'bg-blue-50 border-blue-200',
  headerColor: 'text-blue-700',
  title: 'TOMO 1 — El Sistema Contable en Acción',
  subtitle: '"Del aula a la vida real: por qué la contabilidad importa"',
  content: 'Qué es la contabilidad y para qué sirve · El patrimonio y sus elementos · Variaciones patrimoniales · Situaciones cotidianas convertidas en ejercicios · Identificación y clasificación de cuentas',
  stats: [{
    icon: <PenTool size={14} data-id="element-178" />,
    text: '12 actividades progresivas'
  }, {
    icon: <BarChart size={14} data-id="element-179" />,
    text: '3 proyectos prácticos con contextos reales'
  }, {
    icon: <FileText size={14} data-id="element-180" />,
    text: 'Resolucionario completo con criterios de corrección'
  }]
}, {
  id: 2,
  emoji: '📗',
  color: 'bg-emerald-50 border-emerald-200',
  headerColor: 'text-emerald-700',
  title: 'TOMO 2 — Los Hechos Económicos',
  subtitle: '"La contabilidad que los chicos viven todos los días"',
  content: 'Transacciones comerciales paso a paso · Compras, ventas, pagos y cobros · Documentación comercial · Casos de pequeñas empresas locales · El IVA en operaciones reales',
  stats: [{
    icon: <PenTool size={14} data-id="element-181" />,
    text: '10 actividades con casos reales'
  }, {
    icon: <BarChart size={14} data-id="element-182" />,
    text: '2 proyectos: "Mi negocio del barrio" + "Seguimos una empresa un mes"'
  }, {
    icon: <FileText size={14} data-id="element-183" />,
    text: 'Resolucionario con respuestas modelo y rúbricas'
  }]
}, {
  id: 3,
  emoji: '📙',
  color: 'bg-orange-50 border-orange-200',
  headerColor: 'text-orange-700',
  title: 'TOMO 3 — Del Registro al Informe',
  subtitle: '"Cómo una empresa registra todo lo que le pasa"',
  content: 'Asientos en el Libro Diario · Mayorización paso a paso · Balance de Comprobación · Errores frecuentes de los alumnos y cómo anticiparlos · Proyectos integradores de fin de trimestre',
  stats: [{
    icon: <PenTool size={14} data-id="element-184" />,
    text: '12 actividades con datos reales adaptados'
  }, {
    icon: <BarChart size={14} data-id="element-185" />,
    text: '3 proyectos: "Armamos el diario de una empresa" + "Detectamos el error"'
  }, {
    icon: <FileText size={14} data-id="element-186" />,
    text: 'Resolucionario con gráficos y cuadros resueltos'
  }]
}, {
  id: 4,
  emoji: '📒',
  color: 'bg-yellow-50 border-yellow-200',
  headerColor: 'text-yellow-700',
  title: 'TOMO 4 — El Sistema en Profundidad',
  subtitle: '"SIC II: ajustes, previsiones y la contabilidad que completa el cuadro"',
  content: 'Ajustes contables y regularizaciones · Amortizaciones de bienes de uso · Previsiones e incobrables · Actividades con empresas más complejas · Comparación con casos simples del Tomo 1',
  stats: [{
    icon: <PenTool size={14} data-id="element-187" />,
    text: '10 actividades de profundización progresiva'
  }, {
    icon: <BarChart size={14} data-id="element-188" />,
    text: '2 proyectos: "Cerramos el ejercicio" + "Análisis comparativo de dos empresas"'
  }, {
    icon: <FileText size={14} data-id="element-189" />,
    text: 'Resolucionario con guía de corrección paso a paso'
  }]
}, {
  id: 5,
  emoji: '📔',
  color: 'bg-stone-50 border-stone-200',
  headerColor: 'text-stone-700',
  title: 'TOMO 5 — Información para Decisiones',
  subtitle: '"Cuando los números le hablan a quien tiene que decidir"',
  content: 'Estados Contables completos · Lectura e interpretación básica del Balance · Análisis de resultados · Casos reales adaptados al aula · Conexión entre contabilidad y decisiones empresariales reales',
  stats: [{
    icon: <PenTool size={14} data-id="element-190" />,
    text: '8 actividades integradoras'
  }, {
    icon: <BarChart size={14} data-id="element-191" />,
    text: '3 proyectos transversales con conexiones explícitas entre SIC I y SIC II'
  }, {
    icon: <FileText size={14} data-id="element-192" />,
    text: 'Resolucionario con interpretaciones modelo para orientar la corrección'
  }]
}, {
  id: 6,
  emoji: '📓',
  color: 'bg-slate-100 border-slate-300',
  headerColor: 'text-slate-800',
  title: 'TOMO 6 — Proyectos Integradores Anuales y Cierre',
  subtitle: '"Todo listo para cerrar el año con impacto"',
  content: '3 proyectos integradores completos para SIC I y SIC II · Banco de evaluaciones bimestrales y trimestrales · Rúbricas por competencias · Trabajo en equipo con guía docente · Instrumentos de autoevaluación · Conexión con Economía y Emprendimientos',
  stats: [{
    icon: <PenTool size={14} data-id="element-193" />,
    text: '20 evaluaciones listas'
  }, {
    icon: <BarChart size={14} data-id="element-194" />,
    text: 'Mega-proyecto anual con guía paso a paso'
  }, {
    icon: <FileText size={14} data-id="element-195" />,
    text: 'Resolucionario y criterios de corrección para cada instrumento'
  }]
}];
export function TomosSection() {
  return <section className="py-12 md:py-20 bg-white" data-id="element-196">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="text-center mb-8 md:mb-14" data-id="element-198">
          <h2 className="text-xs font-bold tracking-widest text-[#1a365d] uppercase mb-2" data-id="element-199">
            LOS 6 TOMOS
          </h2>
          <h3 className="text-2xl md:text-4xl font-extrabold text-slate-900 mb-3" data-id="element-200">
            ¿Qué incluye el Sistema?
          </h3>
          <p className="text-base md:text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-201">
            6 TOMOS diseñados para cubrir cada aspecto de tu año escolar — con
            actividades y resolucionario completo
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-8 mb-10 md:mb-16" data-id="element-202">
          {tomos.map((tomo, index) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className={`rounded-xl border-2 p-5 md:p-8 shadow-sm ${tomo.color}`} data-id="element-203">
              <div className="flex items-start gap-3 mb-3" data-id="element-204">
                <span className="text-2xl md:text-4xl" data-id="element-205">{tomo.emoji}</span>
                <div data-id="element-206">
                  <h4 className={`text-base md:text-xl font-bold ${tomo.headerColor} mb-0.5`} data-id="element-207">
                    {tomo.title}
                  </h4>
                  <p className="text-slate-700 italic font-medium text-xs md:text-base" data-id="element-208">
                    {tomo.subtitle}
                  </p>
                </div>
              </div>
              <div className="bg-white/60 p-3 rounded-lg mb-4 text-slate-700 text-xs md:text-sm leading-relaxed border border-white/40" data-id="element-209">
                {tomo.content}
              </div>
              <ul className="space-y-2" data-id="element-210">
                {tomo.stats.map((stat, i) => <li key={i} className="flex items-start gap-2 text-xs md:text-sm font-medium text-slate-800" data-id="element-211">
                    <span className="mt-0.5 text-slate-600 shrink-0" data-id="element-212">
                      {stat.icon}
                    </span>
                    <span data-id="element-213">{stat.text}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        {/* Resolucionario Separado */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#1a365d] text-white rounded-xl p-4 md:p-6 shadow-lg relative overflow-hidden mb-8 md:mb-14" data-id="element-214">
          <div className="flex items-center gap-3 md:gap-5" data-id="element-215">
            <span className="text-3xl md:text-4xl shrink-0" data-id="element-216">📖</span>
            <div className="flex-1 min-w-0" data-id="element-217">
              <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-218">
                <span className="bg-red-500 text-white text-[9px] md:text-[10px] font-bold px-2 py-px rounded-full uppercase tracking-wider" data-id="element-219">
                  Solo para el/la docente
                </span>
                <h4 className="text-sm md:text-lg font-bold" data-id="element-220">
                  RESOLUCIONARIO DOCENTE
                </h4>
              </div>
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-[11px] md:text-xs text-blue-100" data-id="element-221">
                <span data-id="element-222">✅ Respuestas desarrolladas</span>
                <span data-id="element-223">💬 Cómo explicarlo en voz alta</span>
                <span data-id="element-224">⚠️ Errores típicos y cómo anticiparlos</span>
                <span data-id="element-225">🔀 Variantes para adaptar nivel</span>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="text-center" data-id="element-226">
          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-[#d4a017] hover:bg-[#b88a14] text-slate-900 font-bold text-lg px-8 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 inline-flex items-center justify-center gap-2" data-id="element-227">
            👉 Quiero los 6 Tomos ahora
          </button>
        </div>
      </div>
    </section>;
}